import { render, staticRenderFns } from "./AiQuestionGenerator.vue?vue&type=template&id=7a1ae461"
import script from "./AiQuestionGenerator.vue?vue&type=script&lang=ts"
export * from "./AiQuestionGenerator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports